export const KR_FIELDS = {
  employment: {
    type: {
      type: "select",
      props: {
        label: "Employment Type",
        options: [
          {
            label: "Self-employed",
            value: "02"
          },
          {
            label: "Agricultural and Livestock Industries",
            value: "03"
          },
          {
            label: "Office Worker",
            value: "04"
          },
          {
            label: "Public Officer",
            value: "05"
          },
          {
            label: "Student",
            value: "06"
          },
          {
            label: "Etc",
            value: "99"
          }
        ]
      }
    },
    details: {
      type: "input",
      props: {
        label: "Details",
        maxLength: 200
      }
    }
  },
  drugs: {
    answer: {
      type: "yes-no-buttons"
    }
  },
  significant_harm: {
    answer: {
      type: "yes-no-buttons"
    }
  }
}

// Are you currently suffering from any of the following diseases?

// Cholera, Plague, Yellow Fever, Severe Acute Respiratory Syndrome (SARS), Animal Influenza Infection in Humans, New Influenza, Middle East Respiratory Syndrome (MERS), Ebola Virus, Tuberculosis, Marburg Fever, Lassa faver, Crimean Congo Hemorrhagic Fever, Smallpox Variola, Diphtheria, New infectious syndrome
	         
// 1) Have you ever been charged with or convicted of a crime that caused significant harm to the lives or property of others?
// 2) Have you ever been arrested, charged, or convicted of crimes related to possession, use, or distribution of illegal substances such as drugs?  
// 3) Have you ever been arrested, charged, or convicted of a criminal offense that does not fall under items 1) to 2) in your country or abroad?

export const KR_APPLICATION_FIELDS = {
  business_letter: {
		props: {
			type: 'pdf_document',
			message: 'Please upload a copy of a business letter from your employer.',
      client_view: `
        <ul>
          <li>This letter must explain the purpose of the trip and provide a financial guarantee, and specify the dates of travel and the visa duration that is requested.</li>
          <li>The letter should include the contact information for the organization to be visited.</li>
          <li>It must be on letterhead and have a pen-to-paper signature of a representative of the company other than the applicant.</li>
        </ul>
      `,
			friendly_name: 'Business Letter'
		}
	},
  diseases: {
    answer: {
      type: "yes-no-buttons"
    }
  },
  visited_in_the_past: {
    answer: {
      type: "yes-no-buttons"
    }
  },
  contact_number: {
    type: "masked-input",
    props: {
      mask: "-0-0000-0000||-00-0000-0000",
      validation: true,
      prefix: "+82",
      dropSpecialCharacters: false,
      label: "Contact Number in Korea"
    }
  },
  address: {
    type: "input",
    props: {
      label: "Address in Korea",
      maxLength: 200
    }
  },
  exit_flight_number: {
    type: "input",
    props: {
      label: "Flight Number",
      maxLength: 10
    }
  },
  purpose_of_entry: {
    type: "select",
    props: {
      label: "Purpose of Entry",
      options: [
        {
          label: "Tour (Individual Travel)",
          value: "11"
        },
        {
          label: "Tour (Group Tour)",
          value: "10"
        },
        {
          label: "Tour (Incentive Travel)",
          value: "12"
        },
        {
          label: "Visit",
          value: "02"
        },
        {
          label: "Business",
          value: "03"
        },
        {
          label: "Medical Treatment",
          value: "04"
        },
        {
          label: "Meeting",
          value: "05"
        },
        {
          label: "Event",
          value: "06"
        },
        {
          label: "Games/Match/Competition",
          value: "08"
        },
        {
          label: "Other",
          value: "99"
        }
      ]
    }
  },
  purpose_description: {
    type: "textarea",
    props: {
      label: "Description",
      maxLength: 500
    }
  },
  group_tour: {
    agency_name: {
      type: "input",
      props: {
        label: "Travel Agency Name",
        maxLength: 100
      }
    },
    agency_phone: {
      type: "input",
      props: {
        label: "Travel Agency Phone",
        maxLength: 20
      }
    }
  }
}
